<script>
  import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
  import IntegrationsTestnet from "@/public/components/elements/integrations/IntegrationsTestnet.vue";
  import ModalTestnet from "@/public/components/modals/integrations/ModalTestnet.vue";
  import IntegrationsSdk from "@/public/components/elements/integrations/integrationsSdk.vue";
  import IntegrationsFaucetBnb from "@/public/components/elements/integrations/integrationsFaucetBnb.vue";
  import IntegrationsFaucetEth from "@/public/components/elements/integrations/integrationsFaucetEth.vue";
  import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
  import ModalFaucet from "@/public/components/modals/integrations/ModalFaucet.vue";
  import selectOrganization from "@/public/graphQl/mutations/selectOrganization";
  import IntegrationsSettings from "@/public/components/elements/integrations/integrationsSettings.vue";

  export default{
    name: "integrations",
    components: {
      IntegrationsSettings,
      ModalFaucet,
      IntegrationsFaucetEth,
      IntegrationsFaucetBnb, IntegrationsSdk, ModalTestnet, IntegrationsTestnet, BaseButton},
    data () {
      return {
        isApollo: import.meta.env.VITE_PRODUCT_NAME === 'Apollopayment'
      }
    },
    methods: {
      ...mapActions('app', [
        'clearAllStores',
        'init',
        'request',
        'fetchOrganizations',
      ]),
      ...mapMutations('app', ['selectOrganization', 'isInit']),
      ...mapActions('organizations', [
        'getUserOrganizationRole',
      ]),
      ...mapActions('user', [
        'fetchApiKeys',
      ]),
      async handleSelectTestnet () {
        this.clearAllStores()
        this.isInit(false)
        this.selectOrganization(this.testnetOrganization.id)
        await this.request({
          type: 'mutation',
          gql: selectOrganization,
          variables: {
            organizationId: this.testnetOrganization.id,
          },
        });
        await this.getUserOrganizationRole();
        await this.fetchApiKeys();
        await this.init();
      },
    },
    computed: {
      ...mapGetters('app', ['getSelectedOrganization']),
      ...mapState('app', ['organizations']),
      githubLink () {
        return this.isApollo ? 'https://github.com/apollopayment' : 'https://github.com/onchainpay'
      },
      docsLinkRu () {
        return this.isApollo ? 'https://docs.apollopayment.io/' : 'https://docs.onchainpay.io/v/ru'
      },
      docsLinkEn () {
        return this.isApollo ? 'https://docs.apollopayment.io/v/english-2' : 'https://docs.onchainpay.io/'
      },
      testnetOrganization () {
        return this.organizations.find(({ isTest }) => isTest);
      },
      isTestnetOrganization () {
        return this.getSelectedOrganization.isTest
      }
    }
  }
</script>

<template>
<div class="integrations">
  <IntegrationsTestnet :isTestnetOrganization="isTestnetOrganization" :testnetOrganization="testnetOrganization" @handleSelectTestnet="handleSelectTestnet" />
  <div class="docs">
    <div class="header">
      <div class="docs__title">
        Docs
      </div>
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" fill="#191C1F"/>
        <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke="var(--secondary-color)"/>
        <path d="M24.6444 27.7934C26.0886 28.6269 26.8107 29.0437 27.6037 29.0444C28.3968 29.0451 29.1196 28.6295 30.5653 27.7985L39.7806 22.5013C40.1965 22.2622 40.453 21.8189 40.453 21.3391C40.453 20.8592 40.1965 20.416 39.7806 20.1768L30.5619 14.8777C29.1178 14.0476 28.3957 13.6325 27.6035 13.6328C26.8112 13.6331 26.0895 14.0487 24.6461 14.88L16.7211 19.4437C16.6624 19.4775 16.633 19.4944 16.6056 19.5105C13.8986 21.0952 12.226 23.9884 12.2037 27.1252C12.2034 27.1569 12.2034 27.1907 12.2034 27.2585C12.2034 27.3262 12.2034 27.3601 12.2037 27.3917C12.226 30.525 13.8948 33.4155 16.597 35.0014C16.6243 35.0175 16.6537 35.0344 16.7123 35.0683L21.6765 37.9344C24.5691 39.6045 26.0154 40.4396 27.6037 40.4401C29.1919 40.4406 30.6388 39.6066 33.5325 37.9384L38.7728 34.9175C40.2218 34.0822 40.9463 33.6646 41.3441 32.9761C41.7419 32.2876 41.7419 31.4513 41.7419 29.7789V26.548C41.7419 26.084 41.4906 25.6564 41.0852 25.4307C40.693 25.2122 40.2149 25.2154 39.8257 25.4392L29.0803 31.616C28.3593 32.0304 27.9988 32.2376 27.6033 32.2378C27.2077 32.2378 26.8471 32.0308 26.1259 31.6169L18.8532 27.4422C18.4889 27.2331 18.3067 27.1285 18.1604 27.1096C17.8268 27.0665 17.5061 27.2534 17.3791 27.5648C17.3233 27.7014 17.3245 27.9114 17.3267 28.3315C17.3284 28.6407 17.3292 28.7953 17.3581 28.9376C17.4229 29.2561 17.5904 29.5444 17.8351 29.7584C17.9443 29.854 18.0782 29.9313 18.3461 30.0858L26.1218 34.5737C26.8449 34.991 27.2064 35.1997 27.6034 35.1998C28.0004 35.1999 28.3621 34.9914 29.0853 34.5745L38.6161 29.0806C38.8632 28.9382 38.9867 28.867 39.0793 28.9205C39.1719 28.974 39.1719 29.1166 39.1719 29.4018V30.8672C39.1719 31.2854 39.1719 31.4944 39.0725 31.6666C38.9731 31.8387 38.7919 31.9431 38.4296 32.1519L30.5686 36.6833C29.1214 37.5175 28.3978 37.9346 27.6036 37.9342C26.8093 37.9339 26.086 37.5161 24.6396 36.6806L17.2849 32.4321C17.2616 32.4186 17.2499 32.4118 17.239 32.4055C15.6969 31.5044 14.7454 29.8558 14.7365 28.0698C14.7364 28.0572 14.7364 28.0437 14.7364 28.0167V26.6715C14.7364 25.6855 15.2616 24.7742 16.1146 24.2797C16.8684 23.8428 17.7981 23.842 18.5527 24.2775L24.6444 27.7934Z" fill="#F2F7F7"/>
      </svg>
    </div>
    <div class="docs__links">
      <a :href="docsLinkEn" target="_blank">
        <base-button type="primary">
          <template #label>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_20621_121800)">
                <path d="M1 1H17V17H1V1Z" fill="#004DE0"/>
                <path d="M2.875 1L8.975 7.03333L15.05 1H17V3.06667L11 9.03333L17 14.9667V17H15L9 11.0333L3.025 17H1V15L6.975 9.06667L1 3.13333V1H2.875Z" fill="white"/>
                <path d="M11.6 10.3667L17 15.6667V17L10.225 10.3667H11.6ZM7 11.0333L7.15 12.2L2.35 17H1L7 11.0333ZM17 1V1.1L10.775 7.36667L10.825 5.9L15.75 1H17ZM1 1L6.975 6.86667H5.475L1 2.4V1Z" fill="#FE1200"/>
                <path d="M7.025 1V17H11.025V1H7.025ZM1 6.33333V11.6667H17V6.33333H1Z" fill="white"/>
                <path d="M1 7.43333V10.6333H17V7.43333H1ZM7.825 1V17H10.225V1H7.825Z" fill="#FE1200"/>
              </g>
              <rect x="1" y="1" width="16" height="16" rx="8" stroke="white" stroke-opacity="0.2"/>
              <defs>
                <clipPath id="clip0_20621_121800">
                  <rect x="1" y="1" width="16" height="16" rx="8" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span class="label">ENG</span>
          </template>
        </base-button>
      </a>
      <a :href="docsLinkRu" target="_blank">
        <base-button type="primary">
          <template #label>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_20621_121818)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 0H16.5V16H0.5V0Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 5.33398H16.5V16.0007H0.5V5.33398Z" fill="#004DE0"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 10.666H16.5V15.9993H0.5V10.666Z" fill="#FE1200"/>
              </g>
              <rect x="1" y="0.5" width="15" height="15" rx="7.5" stroke="white" stroke-opacity="0.2"/>
              <defs>
                <clipPath id="clip0_20621_121818">
                  <rect x="0.5" width="16" height="16" rx="8" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span class="label">RU</span>
          </template>
        </base-button>
      </a>
    </div>
  </div>
  <div class="docs">
    <div class="header">
      <div class="docs__title">
        GitHub
      </div>
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5625" y="0.5625" width="52.875" height="52.875" rx="26.4375" fill="black"/>
        <rect x="0.5625" y="0.5625" width="52.875" height="52.875" rx="26.4375" stroke="var(--secondary-color)" stroke-width="1.125"/>
        <path d="M24.1254 13.237C20.3129 14.087 17.1879 16.1995 15.0379 19.3995C11.2754 25.037 12.0254 32.5995 16.8254 37.4245C18.2629 38.8745 20.4504 40.2745 22.1004 40.812C22.7129 41.012 22.7879 41.012 23.0629 40.8245C23.3629 40.6245 23.3754 40.5745 23.3754 39.137V37.662L22.2754 37.7245C20.9879 37.787 19.9879 37.562 19.3879 37.0495C19.1754 36.8745 18.7629 36.2745 18.4754 35.7245C18.0004 34.7995 17.6504 34.3745 16.6754 33.512C16.3504 33.2245 16.3379 33.212 16.5629 33.0495C17.1004 32.6495 18.1879 33.037 18.8754 33.862C20.0754 35.3245 20.5379 35.712 21.2254 35.862C21.8379 35.987 22.4004 35.937 23.2504 35.687C23.3629 35.6495 23.5129 35.387 23.5879 35.087C23.6629 34.7995 23.8629 34.362 24.0254 34.1245L24.3254 33.687L23.3129 33.487C21.1879 33.0495 19.8754 32.287 19.0129 30.987C18.2129 29.787 17.9504 28.7495 17.9379 26.812C17.9379 24.987 18.1379 24.237 18.9254 23.212C19.2754 22.762 19.3129 22.6245 19.2129 22.362C19.0254 21.912 19.0754 20.012 19.2754 19.437C19.4379 19.012 19.5254 18.937 19.8629 18.8995C20.4254 18.837 21.4754 19.1995 22.5379 19.7995L23.4504 20.3245L24.2504 20.137C25.3879 19.8745 28.8004 19.887 29.8254 20.137L30.6004 20.337L31.3254 19.8995C32.2879 19.3245 33.5129 18.8745 34.1254 18.8745C34.6129 18.8745 34.6129 18.887 34.8129 19.5245C35.0254 20.262 35.0629 21.5995 34.8754 22.237C34.7754 22.612 34.8004 22.7245 35.0754 23.087C36.4379 24.887 36.5879 27.8745 35.4379 30.3245C34.6629 31.937 33.0254 33.062 30.8254 33.4745L29.7754 33.6745L30.1629 34.362L30.5629 35.062L30.6004 37.8495L30.6504 40.637L30.9629 40.837C31.2504 41.0245 31.3129 41.0245 31.9129 40.812C32.9129 40.4745 34.6254 39.5495 35.5629 38.837C41.1379 34.662 42.9379 27.1745 39.8504 20.9495C38.0379 17.287 34.6129 14.4745 30.6879 13.4245C28.9754 12.9745 25.7504 12.8745 24.1254 13.237Z" fill="white"/>
      </svg>
    </div>
    <div class="docs__links">
      <a :href="githubLink" target="_blank">
        <base-button type="primary">
          <template #label>
            <span class="label">{{ $t('testnet.redirect') }}</span>
          </template>
        </base-button>
      </a>
    </div>
  </div>
  <integrations-sdk />
  <template v-if="!isTestnetOrganization">
    <integrations-settings />
  </template>
  <template v-if="isTestnetOrganization">
    <integrations-faucet-bnb />
    <integrations-faucet-eth />
  </template>
  <ModalTestnet @goToTestnet="handleSelectTestnet" />
  <ModalFaucet />
</div>
</template>

<style scoped lang="scss">
.integrations {
  font-family: $Gilroy;
  padding: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 300px;
  gap: 20px;
  @media screen and (max-width: 1440px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 10px;
  }
}
.docs {
  height: 100%;
  width: 100%;
  padding: 30px;
  border-radius: 30px;
  background: var(--bg-background-secondary);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__links {
    display: flex;
    flex-direction: column;
    gap:  10px;
  }
  &__title {
    color: var(--text-text-primary, #000);
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
